__turbopack_context__.v({
  "className": "poppins_742acfd1-module__qRACpG__className",
  "variable": "poppins_742acfd1-module__qRACpG__variable",
});
